var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLearning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.441 1.104a.985.985 0 0 0-.882 0L.365 5c-.487.253-.487.747 0 1L7.56 9.896a.985.985 0 0 0 .882 0L15.635 6c.487-.253.487-.747 0-1L8.44 1.104Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14 5.5.016 4.514c.002.548.447.99.994.99a.99.99 0 0 0 .99-.99V5.5h-2ZM3.371 9.047l4.387 2.432a.5.5 0 0 0 .485 0l4.39-2.432a.25.25 0 0 1 .371.218v2.955a.25.25 0 0 1-.134.222l-4.635 2.436a.5.5 0 0 1-.466 0l-4.635-2.436A.25.25 0 0 1 3 12.22V9.265a.25.25 0 0 1 .371-.218Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearning);
export default __webpack_public_path__ + "static/media/learning.03ee1e31e603bb73b3c8fb3f8ba0b3c4.svg";
export { ForwardRef as ReactComponent };